import React, { memo } from 'react'
import { Card, Link, Stack } from '@mui/material'
import { Trans } from 'react-i18next'
import { faEarthAmerica } from '@fortawesome/pro-duotone-svg-icons'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import customConfig from 'customConfig'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import CustomForm from '../shared/inputs/CustomForm'
import CustomAutoComplete from '../shared/inputs/CustomAutoComplete'
import { FlagIcon } from '../shared/flag-icon'
import { buildCountriesOptions } from '../../util/country.helpers'
import { countriesObj } from '../../data/countries'
import CustomAlert from '../shared/customAlert/CustomAlert'
import brandConfig from 'brandConfig'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const ChangeCountry = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, countryTemp, isProcessing },
  t,
  isPresent,
  isKycSuccess
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CustomForm onFormSubmit={onFormSubmit}>
        <CardHeading
          title={t('country-settings.country')}
          desc={t(customConfig.countrySettingsDescLabel)}
        />
        <CustomAutoComplete
          label={t('country-settings.country')}
          placeholder={t('shop.select-option')}
          options={buildCountriesOptions()}
          error={t(error[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          success={t(success[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          value={
            countryTemp
              ? { value: countryTemp, label: countriesObj[countryTemp] }
              : {}
          }
          onChange={(value) =>
            dispatchAction(ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP, value)
          }
          startIcon={
            countryTemp && (
              <FlagIcon
                code={countryTemp}
                sx={{ width: 24, height: 24, borderRadius: '50%' }}
              />
            )
          }
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.value}>
                <FlagIcon
                  code={option.value}
                  sx={{ width: 24, height: 24, borderRadius: '50%', mr: 1 }}
                />
                {option.label}
              </li>
            )
          }}
          disabled={isKycSuccess}
        />
        <Stack
          spacing={3}
          sx={{
            mt: 3,
            alignItems: 'flex-end'
          }}
        >
          {isKycSuccess ? (
            <CustomAlert
              severity='info'
              icon={<FaIcon icon={faEarthAmerica} />}
              desc={
                <Trans i18nKey='kyc.contact-change-country'>
                  <Link
                    href={`mailto:${brandConfig.supportEmail}?subject=`}
                    {...NAVIGATION_BLANK_PARAMS}
                    sx={{ color: 'inherit' }}
                    fontWeight='bold'
                    color='inherit'
                  />
                </Trans>
              }
              sx={{ py: 0.3 }}
            />
          ) : (
            <SubmitButton
              size='default'
              label={t('common.save')}
              loading={isPresent && isProcessing}
            />
          )}
        </Stack>
      </CustomForm>
    </Card>
  )
}

export default memo(ChangeCountry)
